import React, { FC } from 'react';
import classnames from 'classnames';

import styles from './_Play.module.css';

interface PlayProps {
    variant?: 'primary' | 'plus';
}

export const Play: FC<PlayProps> = ({ variant = 'primary' }) => (
    <div className={classnames(styles.root, styles[variant])} />
);
